<div class="max-w-lg mx-auto p-4 shadow-lg rounded-lg"
[ngClass]="{'bg-black': darkMode, 'bg-white': !darkMode}">
  <div class="flex justify-center">
    <img *ngIf="currentIndex < imageUrls().length" [src]="imageStatus[currentIndex].url"
      class="rounded-lg w-full max-h-60 object-cover" />
  </div>

  <div *ngIf="currentIndex < imageUrls().length" class="mt-4 flex justify-between">
    <ui-button text="Reprovar" [icon]="EIcon.Close" [type]="EAlert.DANGER" (action)="rejectImage()"></ui-button>
    <ui-button text="Aprovar" [icon]="EIcon.Check" [type]="EAlert.SUCCESS" (action)="approveImage()"></ui-button>
  </div>

  <div class="mt-4 text-center font-semibold">
    <ui-label *ngIf="currentIndex < imageUrls().length" [tag]="ELabelType.PARAGRAPH" [type]="EAlert.DARK">Imagem {{ currentIndex + 1 }} de {{ imageUrls().length }}</ui-label>
    <ui-label *ngIf="currentIndex >= imageUrls().length" [tag]="ELabelType.PARAGRAPH" [type]="EAlert.DARK">🎉 Todas as imagens foram avaliadas!</ui-label>
  </div>
</div>
